export const en = require('./en.json');
export const sc = require('./sc.json');

export const tc = require("./tc.json");